'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".Tooltip-module_tooltipContainer__ps3cP{display:inline-block;position:relative}.Tooltip-module_tooltipText__05Xlg{align-content:flex-start;align-items:flex-start;background-color:#0e0e0e;border-radius:4px;bottom:100%;box-shadow:0 6px 16px 0 rgba(0,0,0,.12);color:#fff;display:flex;max-width:225px;opacity:0;padding:8px;position:absolute;transition:opacity .3s;visibility:hidden;width:-moz-max-content;width:max-content;z-index:1500}.Tooltip-module_tooltipContainer__ps3cP:hover .Tooltip-module_tooltipText__05Xlg{opacity:1;visibility:visible}";
var styles = {"tooltipContainer":"Tooltip-module_tooltipContainer__ps3cP","tooltipText":"Tooltip-module_tooltipText__05Xlg"};
styleInject["default"](css_248z, 'ca4e7ad2-68bc-4e81-81f7-ab24fdfd6daf');

exports["default"] = styles;
